import { useSnapshot } from 'valtio'
import React, { type ReactElement } from 'react'
import cn from 'classnames'
import { rpOccurrenceProxy } from '../../rpOccurrenceProxy'
import { RpOccurrenceStatusEnum } from '../../../../../../../shared/types/GlobalRPOccurrenceStatuses'
import ExclamationCircleIcon from '../../../../../../../shared/components/ui/icons/ExclamationCircleIcon'
import OutlineButton from '../../../../../../../shared/components/ui/buttons/OutlineButton'
import { openModal, openRetrySlideOver } from '../utils/utils'
import { NormalButton } from '../../../../../../../shared/components/ui/buttons/NormalButton'
import { executeRecurringTransactionMarkAsUnresolved } from '../utils/executeRecurringTransactionMarkAsUnresolved'

export function RpOccurrenceErrorContainer (): ReactElement {
  const { rpOccurrence } = useSnapshot(rpOccurrenceProxy)

  if (!rpOccurrence) {
    return (<></>)
  }

  const unResolved = rpOccurrence.status === RpOccurrenceStatusEnum.FAILED_UNRESOLVED
  const resolved = rpOccurrence.status === RpOccurrenceStatusEnum.FAILED_RESOLVED
  const fontColor = resolved ? 'text-gray-500 ' : 'text-red-400 '
  const iconColor = resolved ? '#888' : '#F87171'

  if (!unResolved && !resolved) {
    return (<></>)
  }

  return (
    <div className="bg-white shadow rounded py-4 mb-8 px-6 ">
      <div className="flex flex-row">
        <span className="text-3xl pr-4">
          <ExclamationCircleIcon color={iconColor} />
        </span>
        <label className={cn(fontColor, ' font-semibold text-xl')}>
          {rpOccurrence.errorName}
        </label>
      </div>
      <p className="pl-12 mt-2 pb-8">
        <div>
          <div className={cn(fontColor, 'pb-1')} />
          <div className={cn(fontColor, 'pb-1')}>
            <span className="font-semibold">Details:</span>&nbsp;
            {rpOccurrence.errorMessage}
          </div>
          <div className={cn(fontColor, 'pb-1')}>
            <span className="font-semibold">Merchant Action:</span>&nbsp;
            {rpOccurrence.merchantAction}
          </div>
        </div>

      </p>
      {unResolved &&
        <>
          <NormalButton onClick={openRetrySlideOver} text="Update Card & Retry" />
          <OutlineButton additionalClasses="w-full my-4 py-2" clickFunction={openModal} text="Mark as Resolved Without Retry" />
        </>}
      {resolved &&
        <OutlineButton additionalClasses="w-full my-4 py-2" clickFunction={executeRecurringTransactionMarkAsUnresolved} text="Mark as Unresolved" />}
    </div>
  )
}
